import {
  
    Table,
    Td,
    Tr,
    Th,
    Tbody,
    Thead,
    Tfoot,
  } from "@chakra-ui/react";
 
  import {  Pagination } from "react-bootstrap";
  import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
  import dateTimeFormat from "jsFunctions/dateTimeFormat";
  import { useEffect, useState } from "react";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
  

  
  const RefundInfo = ({ selectedItem,currency }) => {
    const [totalRefundAmount, setTotalRefundAmount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3; // Number of items to display per page
  
    useEffect(() => {
      if (selectedItem?.rfdInfo?.list && selectedItem?.rfdInfo?.list.length > 0) {
        const listOfPayment = selectedItem?.rfdInfo?.list || [];
        const calculateTotalAmount = listOfPayment.reduce((acc, current) => {
          if (current && current?.amt && current?.amt !== '') {
            return acc + parseFloat(current.amt);
          } else {
            return acc;
          }
        }, 0);
        setTotalRefundAmount(calculateTotalAmount);
      }
    }, [selectedItem]);
  
    // Calculate pagination details
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = selectedItem?.rfdInfo?.list?.slice(indexOfFirstItem, indexOfLastItem) || [];
    const pageCount = Math.ceil(selectedItem?.rfdInfo?.list?.length / itemsPerPage);
  
    return (
      <>
  
        {currentItems.length ? (
          <div className="info-table">
            <Table size="md" className="table-info" variant="striped">
              <Thead>
                <Tr>
                  <Th>No.</Th>
                  <Th>Payee</Th>
                  <Th>RefundAmount</Th>
                  <Th>Bank</Th>
                  <Th>Reference Number</Th>
                  <Th>Date</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((item, index) => (
                  <Tr key={index}>
                    <Td>{indexOfFirstItem + index + 1}</Td>
                    <Td>{item?.pyId?.val}</Td>
                    <Td>
                      <span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span>{" "}
                      {item?.amt ? formatAmountIndianRupees(Number(item?.amt)) : Number(0).toFixed(2)}
                    </Td>
                    <Td>{item?.bnkId?.val}</Td>
                    <Td>{item?.rfNo}</Td>
                    <Td>{dateTimeFormat(item?.pmtDt)}</Td>
                  </Tr>
                ))}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Th colSpan={2}>Total Refund Amount</Th>
                  <Td colSpan={4} className="total-spent">
                    <span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span>{" "}
                    {formatAmountIndianRupees(Number(totalRefundAmount))}
                  </Td>
                </Tr>
              </Tfoot>
            </Table>
  
            {/* Pagination Component */}
            <Pagination className="justify-content-end" style={{ marginTop: '20px' }}>
              <Pagination.Prev 
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} 
                disabled={currentPage === 1} 
              />
              {Array.from({ length: pageCount }, (_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next 
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, pageCount))} 
                disabled={currentPage === pageCount} 
              />
            </Pagination>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
  
  export default RefundInfo;
  